import { useRouter }                              from "next/router";
import Slide                                      from "@mui/material/Slide";
import Divider                                    from "@mui/material/Divider";
import Button                                     from "@mui/material/Button";
import UserIcon                                   from "_public/icon-anonymous-user.svg";
import { DEFAULT_AVATAR_LOGO }                    from "_config/index";
import { useTranslation }                         from "react-i18next";
import { checkForAppleDevice, thirdPartyUiCheck } from "_common/utils";
import ConfirmModal                               from "_components/molecules/confirmModal";
import useStyles                                  from "_styles/organisms/drawer";
import { useSetDrawer }                           from "_common/hooks/global";
import NotificationCount                          from "_components/organisms/notificationTab/components/notificationBellIcon";
import Image                                      from "_components/atoms/image";

import { AboutUsIcon, NotificationBell,
	AppearanceIcon, ArrowIcon, BackIcon,
	DownloadAppIcon, HomeIcon, LiveIcon, /* RightArrowIcon,*/
	TickIcon, ModeratorIcon } from "_root/assets";

import {
	ActiveNotificationIcon
}                                              from "_public/new_design";

const component = props => {
	const {
		showDrawer,
		goHome,
		closeDrawer,
		isLoggedIn,
		userProfile,
		handleLoginPopup,
		handlePopup,
		// setShowLocalePage,
		// hideLocalePage,
		showLocalePage,
		fireNotificationPopUp,
		// isLivePage,
		// isCleverTap
		storeEvent,
		handleAppearanceMenu,
		showAppearanceMenu,
		darkMode,
		handleSelectedTheme,
		goModFeed,
		deviceTheme,
		goToNotifications
	} = props;

	let isCleverTap        = false;
	let installPromptEvent = false;
	const isAppleDevice    = checkForAppleDevice ();
	const classes          = useStyles ( { darkMode, isAppleDevice } );
	const router           = useRouter ();
	const setDrawer        = useSetDrawer ();
	const { t }            = useTranslation ();

	const goToProfile = () => {
		if ( !isLoggedIn )
			return;

		const href = "/profile/[id]";
		const as   = `/profile/${ userProfile.id }`;

		setDrawer ( false );
		router.push ( href, as );
	};

	const redirectTo = href => {
		var a = document.createElement ( "a" );

		a.href = href;
		a.setAttribute ( "target", "_blank" );
		a.click ();
	};

	return (
		<Slide
			direction = "right"
			in        = { showDrawer }
		>
			<div className = { classes.navDrawer }>
				{
					!showLocalePage && (
						<div className = { classes.navContainer }>
							<div>
								<div className = { classes.guestContainer }>
									<div
										style   = { {
											display        : "flex",
											alignItems     : "center",
											width          : "100%",
											justifyContent : "space-between"
										} }
									>
										<div
											onClick = { goToProfile }
											style = { { display: "flex", alignItems: "center" } }
										>
											{userProfile && userProfile.photo ? (
												<div style = { { position: "relative", width: "40px", height: "40px" } }>
													<Image
														alt          = "Rooter Profile"
														className    = { classes.userAvatar }
														src          = { userProfile.photo || DEFAULT_AVATAR_LOGO }
													/>
												</div>
											) : (
												<div className = { classes.guestIcon }>
													<UserIcon />
												</div>
											)}

											<span
												className = { classes.userNameContainer }
											>
												{ userProfile && isLoggedIn ? `Welcome ${ userProfile.name }` : t ( "Hi_Guest" )}
											</span>
										</div>

									</div>

									{
										( !isLoggedIn ) && thirdPartyUiCheck ( "LOGIN_BUTTON" ) && (
											<div>
												<Button
													onClick = { handleLoginPopup }
													size    = "small"
													style   = { {
														backgroundImage : "linear-gradient(rgb(18, 107, 213) 0%, rgb(67, 154, 255) 100%)",
														color           : "#fff",
														border          : "1px solid rgba(0, 0, 0, 0.23)",
														borderRadius    : "7px",
														textTransform   : "none"
													} }
													variant = "outlined"
												>
													{t ( "header_login" )}
												</Button>
											</div>
										)
									}
								</div>

								<Divider className = { classes.dividerStyles } />

								{!showAppearanceMenu ?(
									<div>
										<div
											onClick = { () => handleAppearanceMenu () }
											style = { {
												margin: "5px 0"
											} }
										>
											<div className = { classes.themeSettingContainer }>
												<div style = { { display: "flex", alignItems: "center" } }>
													<div className = { classes.tabsItem }>
														<AppearanceIcon />
													</div>

													<p style = { { margin: "0", marginLeft: "10px" } }>
														Appearance
														{" "}

														{/* <RightArrowIcon /> */}
													</p>
												</div>

												<div style = { { display: "flex", alignItems: "center" } }>
													{deviceTheme ? <p>Device theme</p> : darkMode ? <p>Dark Mode</p> : <p>Light Mode</p>}

													<ArrowIcon className = { classes.menuIcon } />
												</div>
											</div>
										</div>

										<Divider className = { classes.dividerStyles } />

										<Divider className = { classes.dividerStyles } />

										<div>

											<div className = { classes.tabsContainer }
												onClick = { () => goHome () }
											>
												<div className = { classes.tabsItem }>
													<HomeIcon />
												</div>

												<p style = { { margin: "0", marginLeft: "10px" } }>
													{t ( "nav_menu_home" )}
												</p>
											</div>

											{
												isLoggedIn ? (
													<div className = { classes.tabsContainer }
														onClick = { () => {
															goToNotifications ();
															setDrawer ( false );
														} }
													>
														<div className = { classes.tabsItem }>
															<NotificationBell />
														</div>

														<p style = { { margin: "0", marginLeft: "10px" } }>
															{t ( "nav_menu_notifications" )}
														</p>

														<div className = { classes.tabsItem }>
															<NotificationCount />
														</div>
													</div>
												) : null
											}

											{isLoggedIn && userProfile && userProfile.isTagModerator === true && (

												<div
													onClick = { () => goModFeed () }
													style = { {
														margin: "5px 0"

													} }
												>
													<div className = { classes.tabsContainer }>
														<div className = { classes.tabsItem }>
															<ModeratorIcon />
														</div>

														<p style = { { margin: "0", marginLeft: "10px" } }>
															Moderator Section
														</p>
													</div>
												</div>

											)}

											{
												installPromptEvent && thirdPartyUiCheck ( "ADD_PWA" ) && (
													<div
														onClick = { () => {
															installPromptEvent.prompt ();
														} }
														style = { {
														// margin: "5px 0",
															background: "white"
														} }
													>
														<div className = { classes.tabsContainer }>
															<div
																className = { classes.pwaButton }
																style     = { {
																	background: "url(/rooter-logo36.png) no-repeat center"
																} }
															/>

															<p
																style = { {
																	margin     : "0",
																	marginLeft : "10px",
																	fontSize   : "13px",
																	fontWeight : "bold",
																	color      : "#da0b33"
																} }
															>
																{t ( "Add_PWA" )}
															</p>
														</div>
													</div>
												)
											}

											{
												isCleverTap && thirdPartyUiCheck ( "CLEVERTAP_SUBSCRIBE_NOTIFICATIONS" ) && (
													<div
														onClick = { fireNotificationPopUp }
														style = { {
														// margin: "5px 0",
															background: "white"
														} }
													>
														<div className = { classes.tabsContainer }>
															<ActiveNotificationIcon className = { classes.bellIcon }
																style     = { { fill: "#666666" } }
															/>

															<p
																style = { {
																	margin     : "0",
																	marginLeft : "10px",
																	fontSize   : "13px",
																	fontWeight : "bold",
																	color      : "#343434"
																} }
															>
																{t ( "SUB_TO_GET_NOTIFICATIONS" )}
															</p>
														</div>
													</div>
												)
											}

											{thirdPartyUiCheck ( "BECOME_BROADCASTER" ) && (
												<div
													className = { classes.tabsContainer }
													onClick = { () => {
														storeEvent ( "Download", "Side_nav" );
														handlePopup ();
													} }
												>
													<div className = { classes.tabsItem }>
														<LiveIcon />

													</div>

													<div
														style = { {
															padding     : "5px",
															paddingLeft : "10px"

														} }
													>
														<p style = { { margin: "0" } }>
															{t ( "Become_Broadcaster" )}
														</p>

													</div>
												</div>
											)}

											{
												thirdPartyUiCheck ( "ABOUT_US" ) && (
													<div className = { classes.tabsContainer }
														onClick   = { () => {
															storeEvent ( "Side_Nav", "Clicked", "About_Us" );
															redirectTo ( "https://pages.rooter.gg/about-us" );
														} }

													>
														<div className = { classes.tabsItem }>
															<AboutUsIcon />
														</div>

														<span style = { { marginLeft: "10px" } }>About Us</span>
													</div>
												)
											}

											<Divider className = { classes.dividerStyles } />

											{
												thirdPartyUiCheck ( "ABOUT_US" ) && (
													<div className = { classes.tabsContainerDownloadApp }
														onClick   = { () => {
															storeEvent ( "Download", "Side_nav" );
															redirectTo ( "https://rooter.app.link/ZjVfQ2tA2qb" );
														} }

													>
														<div className = { classes.tabsItem }>
															<DownloadAppIcon />
														</div>

														<span style = { { marginLeft: "10px" } }>Download App</span>
													</div>
												)
											}

											<Divider className = { classes.dividerStyles } />

											{
												isLoggedIn && thirdPartyUiCheck ( "LOGOUT_BUTTON" ) && (
													<ConfirmModal
														buttonComponent = { (
															<div>
																<div
																	className = { classes.tabsContainer }
																	onClick = { () => {} }
																	style     = { {
																		color: "red"
																	} }
																>
																	<p
																		style = { {
																			margin     : "0",
																			marginLeft : "10px"
																		} }
																	>
																		{t ( "header_logout" )}
																	</p>

																	{/* <GoogleLogout
															clientId = { process.env.GOOGLE_SIGNIN_CLIENT_ID }
															buttonText = "Logout"
															onLogoutSuccess = { logoutUserGoogle }
														>
														</GoogleLogout> */}
																</div>
															</div>
														) }
														dialogText    = { "Are you sure you want to log out?" }
														performAction = { props.logoutUser }
													/>
												)
											}

										</div>
									</div>
								): (
									<div>
										<div className = { classes.appearMenuHeading }>
											<BackIcon className = { classes.iconStyles }
												onClick = { () => handleAppearanceMenu () }
											/>

											<p className = { classes.menuItemStyles }>Appearance</p>

										</div>

										<div className = { deviceTheme ? classes.themeOptionContainerActive: classes.themeOptionContainer }
											onClick = { () => handleSelectedTheme ( "system" ) }
										>
											<p className = { classes.menuItemStyles }>Use Device Theme</p>

											{deviceTheme && (
												<TickIcon />
											)}
										</div>

										<div className = { darkMode && !deviceTheme ? classes.themeOptionContainerActive: classes.themeOptionContainer }
											onClick = { () => handleSelectedTheme ( "dark" ) }
										>
											<p className = { classes.menuItemStyles }>Dark Mode</p>

											{( darkMode && !deviceTheme ) && (
												<TickIcon />
											)}
										</div>

										<div className = { !darkMode && !deviceTheme ? classes.themeOptionContainerActive: classes.themeOptionContainer }
											onClick = { () => handleSelectedTheme ( "light" ) }
										>
											<p className = { classes.menuItemStyles }>Light Mode</p>

											{( !darkMode && !deviceTheme ) && (
												<TickIcon />
											)}
										</div>
									</div>
								)}
							</div>

							<div>
								<div style = { { margin: "20px 0 0" } }>
									{thirdPartyUiCheck ( "TERMS_AND_PRIVACY" ) && (
										<div style = { { padding: "10px 0 30px 15px", fontSize: "13px" } }>
											<span
												onClick = { () => {
													redirectTo ( "https://www.rooter.gg/blogs" );
												} }
												style   = { { textDecoration: "none", color: "#2283F6" } }
											>
												Blogs

												{" "}
&nbsp;
											</span>

											<span className = { classes.ellipse }></span>

											{" "}

											<span
												onClick = { () => {
													redirectTo ( "https://pages.rooter.gg/terms-of-service" );
												} }
												style   = { { textDecoration: "none", color: "#2283F6" } }
											>
												&nbsp;
												{t ( "nav_menu_tos" )}

												{" "}
&nbsp;
											</span>

											<span className = { classes.ellipse }></span>

											<span
												onClick = { () => {
													redirectTo ( "https://pages.rooter.gg/privacy-policy" );
												} }
												style   = { { textDecoration: "none", color: "#2283F6" } }
											>
												&nbsp;
												{" "}

												{t ( "nav_menu_policy" )}
											</span>
										</div>
									)}

								</div>
							</div>
						</div>
					)
				}

				{
					!showLocalePage && (
						<div onClick = { closeDrawer }
							style   = { { width: "20%", height: "100vh" } }
						>
						</div>
					)
				}
			</div>
		</Slide>
	);
};

export default component;
